export default __webpack_public_path__ + "static/media/4.fbb25ee3.png";